import React from "react";

import { IoIosCloseCircle } from "react-icons/io";

import { Flex, Text, Spacer, Icon, Box } from "@chakra-ui/react";

import ExtensionIcon from "../ExtensionIcon";

const FileInformation = ({
  height,
  width,
  label,
  name,
  setAnexoEditado,
  isVisualizacao,
  maxTextWidth,
  isDisabled,
}) => {
  return (
    <Box width={"216px"}>
      <Text
        color="#5F6377"
        fontWeight="500"
        fontSize="14px"
        lineHeight="19.6px"
        whiteSpace={"nowrap"}
      >
        {label}
      </Text>
      <Flex
        id={label?.replace(/[\s*]/g, "")}
        mt="8px"
        borderRadius="24px"
        flex={height === "auto" ? "1" : null}
        height={{ base: "auto", lg: height ? height : "42px" }}
        width={width && width}
        backgroundColor="#E3E3E3"
        alignItems="center"
        justifyContent="center"
        p={
          height
            ? Number(height.substring(0, height.length - 2)) < 80
              ? "6px"
              : "1px"
            : "1px"
        }
      >
        <Flex h="100%" w="30px" ml={"10px"}>
          <ExtensionIcon path={name} />
        </Flex>
        <Flex flexDir="column" maxW={{ base: "50%", lg: "50%" }} ml="10px">
          <Text
            fontWeight="600"
            fontSize="14px"
            lineHeight="19.6px"
            isTruncated
            color="#1A203D"
            title={name}
            wordBreak="break-word"
            noOfLines={2}
            whiteSpace={"normal"}
          >
            {height
              ? Number(height.substring(0, height.length - 2)) === 120
                ? name.length > 50
                  ? name.substring(0, 50) + "..."
                  : name
                : name.length > 25
                ? name.substring(0, 25) + "..."
                : name
              : name.length > 25
              ? name.substring(0, 25) + "..."
              : name}
          </Text>
        </Flex>
        <Spacer />
        {!isVisualizacao && (
          <>
            <Icon
              id="excluir-arquivo"
              aria-label="Excluir arquivo"
              color={isDisabled ? "#D3D3D3" : "#9EA1AE"}
              as={IoIosCloseCircle}
              boxSize="40px"
              _hover={isDisabled ? {} : { cursor: "pointer" }}
              onClick={() => {
                if (!isDisabled) {
                  setAnexoEditado();
                }
              }}
            />
          </>
        )}
      </Flex>
    </Box>
  );
};

export default FileInformation;
